import type { CheckboxOption } from "@/components/cinch/FilterBar/CheckboxList";

/** Filter chips for the Contracts tabs, wired to the Cinch backend filter params.
 *
 *  MultiSelectChip / DateRangeChip were promoted to the Design System
 *  (components/cinch/FilterBar/chips.tsx) on 2026-08-19 — proposals was
 *  already importing them across the feature boundary, and integrations
 *  would have been the second. Re-exported here so existing imports keep
 *  working; the contracts-specific date-ISO helpers stay local.
 *
 *  Date encoding mirrors the Employee Portal's DateRangeFilter EXACTLY so results
 *  match Cinch: the lower bound is sent as local start-of-day and the upper bound
 *  as local END-of-day (23:59:59.999), both as full ISO datetimes. This keeps the
 *  Accounts DateTimeFilter (gte/lte) inclusive of the end day, and the Contracts
 *  CharFilter (which takes the UTC date part) consistent with the Portal. */

export { DateRangeChip, MultiSelectChip } from "@/components/cinch/FilterBar";

export const PAYMENT_OPTIONS: CheckboxOption[] = [
  { value: "CC", label: "Credit Card" },
  { value: "ACH", label: "ACH" },
  { value: "None", label: "None" },
];

export const ACTIVE_STATUS_OPTIONS: CheckboxOption[] = [
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
];

/** Lower bound: local start-of-day as an ISO datetime (matches the Portal). */
export function startOfDayIso(d: Date | null): string | undefined {
  if (!d) return undefined;
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x.toISOString();
}

/** Upper bound: local end-of-day as an ISO datetime, so the end day is inclusive. */
export function endOfDayIso(d: Date | null): string | undefined {
  if (!d) return undefined;
  const x = new Date(d);
  x.setHours(23, 59, 59, 999);
  return x.toISOString();
}

/** Parse a stored ISO datetime back to a Date for the picker (null if absent/bad). */
export function parseDate(s: string | undefined): Date | null {
  if (!s) return null;
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? null : d;
}
